<template>
  <div>
    <span class="font-weight-bold">{{ label }}: </span>
    <span class="font-weight-light"><slot></slot></span>
  </div>
</template>

<script>
export default {
  name: 'UploadListItemField',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
